.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background-color: var(--bg-gray);
}

.statusTitle {
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    font-size: 1.5rem;
    line-height: 2rem;
    margin: 0;
  }

  button {
    width: 16.5rem;
  }

  .buttons {
    min-height: calc(3.125rem + 2px);
    display: flex;
    align-items: center;
    gap: 1rem;

    button {
      width: fit-content;
    }
  }
}

.statusSection {
  display: flex;
  flex-direction: row;
  gap: 2rem;

  div:has(> nav) {
    margin: 0;
    flex: 0 0 19.5rem;
  }

  nav {
    position: sticky;
    top: 0;
  }
}

.statusArticle {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  flex: 1;
  background-color: var(--base-white);
  border-radius: 0.5rem;

  > div {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}

.cellWithBadge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;

  > span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
